import axios from "../../axios";
export default {
  namespaced: true,
  state: {
    table: {},
  },
  mutations: {
    SET_TABLE(state, products) {
      state.table = products;
    },
  },
  actions: {
    fetchTable({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios
          .get("event/activity_reports/", {
            params,
          })
          .then((response) => {
            commit("SET_TABLE", response.data);
            resolve(response);
          })
          .catch((error) => {
            // console.log(error), reject(error);
          });
      });
    },
    downloadFile(_, params) {
      return new Promise((resolve, reject) => {
        axios
          .get("event/activity_reports", {
            params,
            responseType: "blob", // Add this line to handle the file as a blob
          })
          .then((response) => {
            const fileType = "text/csv";
            const blob = new Blob([response.data], { type: fileType });
            const url = window.URL.createObjectURL(blob);

            // Create a link to download the file
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `report.csv`); // Set the file name and type
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            resolve(response);
          })
          .catch((error) => {
            console.error("File download error:", error);
            reject(error);
          });
      });
    },
  },
};
